import React from 'react';
import { useDispatch } from 'react-redux';
import { onSortItemSelected } from '../../Actions/ProductFiltering.action';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import RadioButton from '../Inputs/Radiobutton';

const ProductSortingRadios = () => {
  const dispatch = useDispatch();
  const { sortCriteria } =
    useTypedSelector((state) => state.productFiltering) ?? {};
  const selectedSortItem = sortCriteria?.sortItems.find((s) => s.selected);

  return (
    <ul className="p-4">
      {sortCriteria?.sortItems.map((item) => (
        <li
          className="flex cursor-pointer items-center justify-between py-2 text-lg [&_div]:m-0"
          key={item.query}
          onClick={() => {
            dispatch(
              onSortItemSelected(
                sortCriteria?.sortItems.find((s) => s.query == item.query)
              )
            );
          }}
        >
          {item.name}{' '}
          <RadioButton
            name="sort-radio"
            checked={selectedSortItem?.query == item.query}
            inputSize="medium"
          />
        </li>
      ))}
    </ul>
  );
};

export default ProductSortingRadios;
